module.exports = __webpack_public_path__ + "img/thumbnail-26health.ec998309.jpg";